import React from 'react';
import { Typography } from '@mui/material';
import { SchoolRounded } from '@mui/icons-material';
import MateriaAlumnoCard, { IngresarCodigoCard, MateriaAlumnoCardSkeleton } from './MateriaAlumnoCard';
import { IMiMateria } from '../../types/miRecurso';
import { PageContainer, HubGrid, HubEmptyState } from './styles';

const SKELETON_COUNT = 3;

interface MisMateriasPageProps {
	materias: IMiMateria[];
	isLoading: boolean;
	onSelectMateria: (materia: IMiMateria) => void;
	onIngresarCodigo: () => void;
}

const MisMateriasPage: React.FC<MisMateriasPageProps> = ({
	materias,
	isLoading,
	onSelectMateria,
	onIngresarCodigo,
}) => {
	if (isLoading) {
		return (
			<PageContainer>
				<HubGrid>
					{Array.from({ length: SKELETON_COUNT }).map((_, i) => (
						<MateriaAlumnoCardSkeleton key={i} />
					))}
				</HubGrid>
			</PageContainer>
		);
	}

	if (materias.length === 0) {
		return (
			<PageContainer>
				<HubEmptyState>
					<SchoolRounded
						style={{ fontSize: '4rem', opacity: 0.2, marginBottom: 12 }}
						color='action'
					/>
					<Typography variant='h6' color='text.secondary' gutterBottom>
						Aún no tienes materias registradas
					</Typography>
					<Typography variant='body2' color='text.secondary'>
						Pídele a tu docente un código de materia e ingrésalo para comenzar.
					</Typography>
				</HubEmptyState>
				<HubGrid>
					<IngresarCodigoCard onClick={onIngresarCodigo} />
				</HubGrid>
			</PageContainer>
		);
	}

	return (
		<PageContainer>
			<HubGrid>
				{materias.map((materia, index) => (
					<MateriaAlumnoCard
						key={materia.id}
						materia={materia}
						colorIndex={index}
						onSelect={() => onSelectMateria(materia)}
					/>
				))}
				<IngresarCodigoCard onClick={onIngresarCodigo} />
			</HubGrid>
		</PageContainer>
	);
};

export default MisMateriasPage;
